import React from 'react';
import ContentLoader from 'react-content-loader';

const FilterPillLoader = ({ className }: { className?: string }) => (
  <ContentLoader
    backgroundColor="#f3f3f3"
    className={className}
    foregroundColor="#ecebeb"
    height={32}
    speed={2}
    viewBox="0 0 97 32"
    width={97}>
    <rect height="32" rx="16" ry="16" width="97" x="0" y="0" />
  </ContentLoader>
);

export default FilterPillLoader;
